import { gql } from "@apollo/client";

export default gql`
  query IsProductTranslationEnabled($slug: String!) {
    isTranslationEnabled(slug: $slug)
  }
`;
